export default __webpack_public_path__ + "static/media/dashboard.7aa58e91.svg";